/**
 * Pet sex utility constants for the WeTree Web UI
 *
 * Note: The actual PetSexType is imported from we-tree-api-client
 */

import { PetSexType as PetSexTypeObject, PetSexType } from 'we-tree-api-client/v2';

// Extract values from the API client's PetSexType object to ensure we stay in sync
export const PET_SEX_VALUES: readonly PetSexType[] = Object.values(PetSexTypeObject);

export const DEFAULT_PET_SEX: PetSexType = 'unknown';

// Re-export the type for convenience
export type { PetSexType };
